module.exports = __webpack_public_path__ + "img/icon_tt_minus.b03d61a2.svg";